module.exports = __webpack_public_path__ + "static/media/corn_loader.e2668696.gif";